import { render, staticRenderFns } from "./Dicomviewer.vue?vue&type=template&id=51d9c0ac&scoped=true"
import script from "./Dicomviewer.vue?vue&type=script&lang=js"
export * from "./Dicomviewer.vue?vue&type=script&lang=js"
import style0 from "./Dicomviewer.vue?vue&type=style&index=0&id=51d9c0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9c0ac",
  null
  
)

export default component.exports